export const tags = [
  { t: "Sets, relations and functions" },
  { t: "Complex numbers and quadratic equations" },
  { t: "Matrices and determinants" },
  { t: "Mathematical reasoning" },
  { t: "Mathematical induction" },
  { t: "Permutations and combinations" },
  { t: "Sequences and series" },
  { t: "Limit, continuity and differentiability" },
  { t: "Integral calculus" },
  { t: "Differential equations" },
  { t: "Binomial theorem and its simple applications" },
  { t: "Three-dimensional geometry" },
  { t: "Vector algebra" },
  { t: "Co-ordinate geometry" },
  { t: "Statistics and probability" },
  { t: "Trigonometry" },
  { t: "Sets" },
  { t: "relations" },
  { t: "functions" },
  { t: "Matrices" },
  { t: "Determinants" },
  { t: "Permutations" },
  { t: "combinations" },
  { t: "Sequences " },
  { t: "series" },
  { t: "Statistics " },
  { t: "probability" },
  { t: "3-D Geometry" },
  { t: "Limit " },
  { t: "continuity" },
  { t: "differentiability" },
  { t: "Complex numbers" },
  { t: "quadratic equations" },
  { t: "Blackbody radiation" },
  { t: "Units" },
  { t: "Dimension" },
  { t: "Vectors" },
  { t: "Kinematics 1D " },
  { t: "Kinematics 2D " },
  { t: "Projectile motion " },
  { t: "Relative Motion" },
  { t: "Friction" },
  { t: "Centrifugal force" },
  { t: "Work and Power" },
  { t: "Moment of Inertia" },
  { t: "Planets and satellites" },
  { t: "Damped and Forced oscillations" },
  { t: "Elasticity" },
  { t: "Pascal’s law" },
  { t: "Wave on strings" },
  { t: "Thermal expansion" },
  { t: "Kinetic Theory Of Gases" },
  { t: "Prism" },
  { t: "YDSE / Young's double slit experiment" },
  { t: "Coulomb’s law" },
  { t: "Equivalent resistance" },
  { t: "Biot–Savart’s law" },
  { t: "Inductances" },
  { t: "Atomic nucleus" },
  { t: "Experiments" },
  { t: "Semiconductors" },
  { t: "Centre of mass " },
  { t: "Angular momentum" },
  { t: "Keplers laws" },
  { t: "Stress and Strain" },
  { t: "Buoyancy" },
  { t: "Sound waves" },
  { t: "Calorimetry" },
  { t: "Simple microscope" },
  { t: "Diffraction" },
  { t: "Gauss’s law " },
  { t: "Heating effect" },
  { t: " Ampere’s law" },
  { t: "AC circuits" },
  { t: " Radioactive decay" },
  { t: "Vernier calipers" },
  { t: "Diode" },
  { t: "Linear momentum" },
  { t: "Rolling motion" },
  { t: "Escape velocity" },
  { t: "Hooke's Law" },
  { t: "Surface tension" },
  { t: "Standing waves" },
  { t: "Heat conduction " },
  { t: "Compound microscope" },
  { t: "Polarisation" },
  { t: "Conductors" },
  { t: " Galvanometer" },
  { t: "RLC Circuits" },
  { t: "Nuclear Physics" },
  { t: "Screw gauge" },
  { t: "Zener diode" },
  { t: "Collision" },
  { t: "Stoke’s law" },
  { t: "Pascal’s law" },
  { t: "Young's modulus" },
  { t: "Capillary rise" },
  { t: "Resonance and beats" },
  { t: " Convection and radiation" },
  { t: "Telescope" },
  { t: "Capacitors" },
  { t: "Magnetic moment" },
  { t: "Photoelectric effect" },
  { t: "Meter bridge" },
  { t: "Transistors" },
  { t: "Impulse" },
  { t: "Viscosity" },
  { t: "Doppler effect" },
  { t: "Newton’s law of cooling" },
  { t: "X-rays" },
  { t: "Post office box" },
  { t: "Logic Gates" },
  { t: "Some Basic Concepts of Chemistry" },
  { t: "Structure of Atom" },
  { t: "General Topics" },
  { t: "Gaseous And Liquid States" },
  { t: "Atomic Structure And Chemical Bonding" },
  { t: "Energetics" },
  { t: "Chemical Equilibrium" },
  { t: "Electrochemistry" },
  { t: "Chemical Kinetics" },
  { t: "Solid State" },
  { t: "Solutions" },
  { t: "Surface chemistry" },
  { t: "Nuclear chemistry" },
  { t: "Classification of Elements and Periodicity in Properties" },
  { t: "General Principles and Processes of Isolation of Metals" },
  { t: "Hydrogen" },
  { t: "S - Block Elements" },
  { t: "P- Block Elements" },
  { t: "d - and f - Block Elements" },
  { t: "Co-Ordination Compounds" },
  { t: "Environmental Chemistry" },
  { t: "Purification and Characterization of Organic Compounds" },
  { t: "Some Basic Principles of Organic Chemistry" },
  { t: "Hydrocarbons" },
  { t: "Organic Compounds Containing Halogens" },
  { t: "Organic Compounds Containing Oxygen" },
  { t: "Organic Compounds Containing Nitrogen" },
  { t: "Polymers" },
  { t: "Biomolecules" },
  { t: "Chemistry In Everyday Life" },
  { t: "introduction to physics" },
  { t: "kinematics" },
  { t: "newton's laws of motion" },
  { t: "circular motion" },
  { t: "mechanics" },
  { t: "rotational mechanics" },
  { t: "gravitation" },
  { t: "simple harmonic motion" },
  { t: "mechanical properties of matter" },
  { t: "fluid mechanics" },
  { t: "wave motion" },
  { t: "thermal physics" },
  { t: "themodynamics" },
  { t: "geometrical optics" },
  { t: "wave optics" },
  { t: "electrostatics" },
  { t: "electric current" },
  { t: "magnetic field" },
  { t: "electromagnetic induction" },
  { t: "modern physics" },
  { t: "error analysis" },
  { t: "electronic devices" },
  { t: "communication systems" }
];
